'use client';

import type { ControllerRenderProps } from 'react-hook-form/dist/types/controller';
import React, { useState, forwardRef } from 'react';
import type { FieldValues } from 'react-hook-form';
import { Input } from '../InputV2/Input';
import { Privacy } from '../../icons/icons/Various/Privacy';
import { HidePrivacy } from '../../icons/icons/Various/HidePrivacy';
import { UnstyledButton } from '../ButtonV2/Button';

export interface PasswordInputProps<T extends FieldValues> {
  label: string;
  autoComplete?: string;
  field?: ControllerRenderProps<T>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PasswordInput = forwardRef<
  React.ElementRef<typeof Input>,
  React.PropsWithoutRef<PasswordInputProps<FieldValues>>
>(({ label, autoComplete, ...field }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPasswordToggle = (event) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  return (
    <div className='relative'>
      <Input
        label={label}
        {...field}
        autoComplete={autoComplete}
        labelClassNames='max-w-[calc(100%-40px)]'
        ref={ref}
        type={showPassword ? 'text' : 'password'}
      />
      <UnstyledButton
        aria-label={showPassword ? 'hide password' : 'show password'}
        className='absolute right-4 top-1/2 z-10 -translate-y-1/2'
        onClick={handleShowPasswordToggle}
        type='button'
      >
        {showPassword ? (
          <HidePrivacy
            fill='#969696'
            height={20}
            title='hide password'
            width={20}
          />
        ) : (
          <Privacy
            fill='#969696'
            height={20}
            title='show password'
            width={20}
          />
        )}
      </UnstyledButton>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';
